import React from 'react';
import isNil from 'lodash/isNil';
import {
	FireScreenAnalytics,
	ContextualAnalyticsData,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import type { ImportType } from '../../common/constants/import-type';
import { X2C_SCREENS } from '../../common/constants/metrics';
import { StepFooterStandard } from '../../common/ui/step-footer';
import { ProgressBarStandard } from '../../common/ui/step-progress-bar';
import { StepScreen } from '../../common/ui/step-screen';
import { useUploadedFileName } from '../../controllers/import-state';
import { useProductSteps } from '../../controllers/utils';
import { Guide } from './guide';
import { UploadCSVDropZone } from './upload-csv-dropzone';
import { useContent } from './utils';

type UploadScreenProps = {
	onClose: () => void;
	onNext: (importType?: ImportType) => void;
	onCloseAndReturnToUploadStep: () => void;
	onReturn: () => void;
	isCompact?: boolean;
	importType?: ImportType;
};

export const UploadScreenStandard = ({
	onClose,
	onNext,
	onReturn,
	onCloseAndReturnToUploadStep,
	isCompact = true,
	importType,
}: UploadScreenProps) => {
	const { heading, description } = useContent(importType);
	const { productSteps, currentStepIndex } = useProductSteps();
	const [uploadedFileName] = useUploadedFileName();

	return (
		<ContextualAnalyticsData sourceName={X2C_SCREENS.UPLOAD_CSV} sourceType={SCREEN}>
			<StepScreen
				renderProgressBar={
					!isCompact && (
						<ProgressBarStandard
							productSteps={productSteps}
							currentStepIndex={currentStepIndex}
							onClose={onCloseAndReturnToUploadStep}
						/>
					)
				}
				header={heading}
				description={description}
				renderFooter={
					!isCompact && (
						<StepFooterStandard
							alignRight
							onReturn={onReturn}
							shouldDisableNext={isNil(uploadedFileName)}
							onClickNext={() => onNext()}
							isFixedPosition
						/>
					)
				}
			>
				<UploadCSVDropZone onNext={onNext} onClose={onClose} isCompact={isCompact} />
				<Guide importType={importType} />
				<FireScreenAnalytics />
			</StepScreen>
		</ContextualAnalyticsData>
	);
};
